import type { ChartConfig } from '@/features/(charts)/chart-renderer/ui/Cross/types';
import { getPercentStringFormat } from '@/utils/util';

import { SentimentCalculator } from './SentimentCalculator';

/**
 * 셀 값 계산을 담당하는 클래스
 */
export class CellValueCalculator {
  /**
   * 설정에 따라 셀 값을 계산
   *
   * @param config - 차트 설정
   * @param value - 원본 값
   * @param totalForPercentage - 퍼센트 계산을 위한 전체 값
   * @param values - z축 값들 (감성 계산용, 선택적)
   * @returns 계산된 셀 값
   */
  static calculate(
    config: ChartConfig,
    value: number,
    totalForPercentage: number,
    values?: { value: number; z: StringNumberValue }[],
  ): number {
    // 감성 기반 셀 계산
    if (config.isCellSentimentCalculation && values) {
      return Number(
        SentimentCalculator.calculateSentimentPercentage(
          values,
          value,
          config.sentimentSegment,
        ).toFixed(2),
      );
    }

    // 퍼센트 계산
    if (config.isPercentage) {
      return Number(getPercentStringFormat(totalForPercentage, value, 2));
    }

    // 일반 값
    return value;
  }
}
